import { CreateOrEdit } from "./CreateOrEdit";
import { Table } from "./Table";

export const AdminPages = {
	Table,
	CreateOrEdit,
};
